<template>
	<div>
		<app-header></app-header>
        <div class="mb-150"></div>
		<div>
            <v-container fluid grid-list-xl>
                <v-layout row wrap align-center justify-center>
                    <v-flex xs12 md10 lg10 class="col-height-auto" mt-6>
                        <v-card>
                            <!-- <v-toolbar color="aquamarine" dark>
                                <v-toolbar-title>Micro Article</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-text-field v-show="isShowSearchField" v-model="searchText" class="mx-3" flat label="Search" @change="getMicroArticleSearchList"></v-text-field>
                                <v-btn icon @click="isShowSearchField = !isShowSearchField">
                                    <v-icon>search</v-icon>
                                </v-btn>
                            </v-toolbar> -->
                            <v-expansion-panel>
                                <v-expansion-panel-content>
                                    <div slot="header" class="font-md">
                                        {{$t("microArticles.publishMessage")}}
                                    </div>
                                    <v-card-text>
                                        <v-form ref="microArticleForm" v-model="microArticleVaild">
                                            <v-textarea
                                                color="aquamarine"
                                                v-model="microArticleForm.content"
                                                :rules="microArticleContentRules"
                                                @input="changeContent"
                                                auto-grow required outline>
                                            </v-textarea>
                                            <div class="right">
                                                <v-progress-circular 
                                                    v-show="contentPercentage <= 100" 
                                                    :rotate="-90" :size="30" :width="1" 
                                                    :value="contentPercentage" 
                                                    color="aquamarine"> 
                                                    {{ availableContentLength }} 
                                                </v-progress-circular>
                                                <v-progress-circular 
                                                    v-show="contentPercentage > 100" 
                                                    :rotate="-90" :size="30" :width="1" 
                                                    :value="contentPercentage" 
                                                    color="error"> 
                                                    {{ availableContentLength }} 
                                                </v-progress-circular>
                                                <v-btn small outline round 
                                                    color="aquamarine" 
                                                    :disabled="!microArticleVaild" 
                                                    :loading="publishBtnLoading" 
                                                    @click="createMicroArticle">
                                                    {{$t("microArticles.publish")}}
                                                </v-btn>
                                            </div>
                                        </v-form>
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-tabs right class="aquamarine--text" slider-color="aquamarine" show-arrows>
                                <v-tab @click="tabName = 'hot'">
                                    <span class="fw-bold">{{$t("microArticles.hot")}}</span>
                                </v-tab>
                                <v-tab @click="tabName = 'new'">
                                    <span class="fw-bold">{{$t("microArticles.new")}}</span>
                                </v-tab>
                                <v-tab v-show="microArticleSearchList.length > 0" @click="tabName = searchText">
                                    <span class="fw-bold">{{searchText}}</span>
                                </v-tab>
                                <!-- - - - - - - - - - - - - - - - - - - - - - - - - -  -->
                                <!-- - - - - - - - - - - - - HOT - - - - - - - - - - -  -->
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-divider></v-divider>
                                            <template v-for="(microArticle, index) in microArticleHotList">
                                                <div class="mt-3 mb-3 ml-3 mr-3">
                                                    <v-avatar class="pointer" size="40" @click="goUserData(microArticle.userName)">
                                                        <img :src="microArticle.image">
                                                    </v-avatar>
                                                    <span class="ml-3 font-lg pointer hover-color" @click="goUserData(microArticle.userName)">{{microArticle.nickName}}</span>
                                                    <span class="ml-3 font-lg">{{ dateFormat(microArticle.time)}}</span>
                                                    <div class="mt-3  font-md pointer hover-color" @click="gotoMicroArticle(microArticle)">
                                                        {{microArticle.content}}
                                                    </div>
                                                </div>
                                                <div class="mr-5 right">
                                                    <v-icon small :class="{'aquamarine--text':microArticle.isUpvote}" :title="$t('posting.upvote')" @click="voteMicroArticle(microArticle, '0')">thumb_up</v-icon>
                                                    {{microArticle.upvoteCount}}
                                                    <!-- <v-icon small :title="$t('postingsel.tread')" class="ml-3" @click="">thumb_down</v-icon>
                                                    {{microArticle.downvoteCount}} -->
                                                    <v-icon small :title="$t('posting.comment')" class="ml-3" @click="gotoMicroArticle(microArticle)">fa fa-comment</v-icon>
                                                    {{microArticle.commentCount}}
                                                </div>
                                                <v-divider class="mt-5"></v-divider>
                                            </template>
                                        </v-card-text>
                                        <!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
                                        <infinite-loading :identifier="tabName" @infinite="getMicroArticleHotList" class="mb-3">
                                            <div slot="spinner">
                                                <v-progress-circular indeterminate color="aquamarine"></v-progress-circular>
                                            </div>
                                            <div slot="no-more">{{$t("microArticles.noMore")}}</div>
                                            <div slot="no-results">{{$t("microArticles.noResults")}}</div>
                                        </infinite-loading>
                                    </v-card>
                                </v-tab-item>
                                <!-- - - - - - - - - - - - - - - - - - - - - - - - - -  -->
                                <!-- - - - - - - - - - - - - NEW - - - - - - - - - - -  -->
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-divider></v-divider>
                                            <template v-for="(microArticle, index) in microArticleNewList">
                                                <div class="mt-3 mb-3 ml-3 mr-3">
                                                    <v-avatar class="pointer" size="40" @click="goUserData(microArticle.userName)">
                                                        <img :src="microArticle.image">
                                                    </v-avatar>
                                                    <span class="ml-3 font-lg pointer hover-color" @click="goUserData(microArticle.userName)">{{microArticle.nickName}}</span>
                                                    <span class="ml-3 font-lg">{{ dateFormat(microArticle.time)}}</span>
                                                    <div class="mt-3 font-md pointer hover-color" @click="gotoMicroArticle(microArticle)">
                                                        {{microArticle.content}}
                                                    </div>
                                                </div>
                                                <div class="mr-5 right">
                                                    <v-icon small :class="{'aquamarine--text':microArticle.isUpvote}" :title="$t('posting.upvote')" @click="voteMicroArticle(microArticle, '0')">thumb_up</v-icon>
                                                    {{microArticle.upvoteCount}}
                                                    <!-- <v-icon small :title="$t('postingsel.tread')" class="ml-3" @click="">thumb_down</v-icon>
                                                    {{microArticle.downvoteCount}} -->
                                                    <v-icon small :title="$t('posting.comment')" class="ml-3" @click="gotoMicroArticle(microArticle)">fa fa-comment</v-icon>
                                                    {{microArticle.commentCount}}
                                                </div>
                                                <v-divider class="mt-5"></v-divider>
                                            </template>
                                        </v-card-text>
                                        <!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
                                        <keep-alive>
                                            <infinite-loading :identifier="tabName" @infinite="getMicroArticleNewList" class="mb-3">
                                                <div slot="spinner">
                                                    <v-progress-circular indeterminate color="aquamarine"></v-progress-circular>
                                                </div>
                                                <div slot="no-more">{{$t("microArticles.noMore")}}</div>
                                                <div slot="no-results">{{$t("microArticles.noResults")}}</div>
                                            </infinite-loading>
                                        </keep-alive>
                                    </v-card>
                                </v-tab-item>
                                <!-- - - - - - - - - - - - - - - - - - - - - - - - - -  -->
                                <!-- - - - - - - - - - - - - SearchText - - - - - - - - - - -  -->
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <v-divider></v-divider>
                                            <template v-for="(microArticle, index) in microArticleSearchList">
                                                <div class="mt-3 mb-3 ml-3 mr-3">
                                                    <v-avatar class="pointer" size="40" @click="goUserData(microArticle.userName)">
                                                        <img :src="microArticle.image">
                                                    </v-avatar>
                                                    <span class="ml-3 font-lg pointer hover-color" @click="goUserData(microArticle.userName)">{{microArticle.nickName}}</span>
                                                    <span class="ml-3 font-lg">{{ dateFormat(microArticle.time)}}</span>
                                                    <div class="mt-3 font-md pointer hover-color" @click="gotoMicroArticle(microArticle)">
                                                        {{microArticle.content}}
                                                    </div>
                                                </div>
                                                <v-divider></v-divider>
                                            </template>
                                        </v-card-text>
                                        <!--infinite-loading这个组件要放在列表的底部，滚动的盒子里面！-->
                                        <keep-alive>
                                            <infinite-loading :identifier="tabName" @infinite="getMicroArticleSearchList" class="mb-3">
                                                <div slot="spinner">
                                                    <v-progress-circular indeterminate color="aquamarine"></v-progress-circular>
                                                </div>
                                                <div slot="no-more">{{$t("microArticles.noMore")}}</div>
                                                <div slot="no-results">{{$t("microArticles.noResults")}}</div>
                                            </infinite-loading>
                                        </keep-alive>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
	</div>
</template>
<style>

</style>
<script>
    import Vue from 'vue'
    import config from '../../config.js'
    import InfiniteLoading from 'vue-infinite-loading';
    export default {
        data(){
            return{
                tabName: 'hot',                         // 标签名
                microArticleNewList: [],                // 按时间排序的微文集合
                microArticleHotList: [],                // 按热度排序的微文集合
                microArticleSearchList: [],             // 按搜索文本排序的微文集合
                microArticleVaild: true,                // 发布微文的验证
                microArticleForm: {                     // 提交的微文对象
                    userId: this.$store.state.user.id,
                    content: '',
                    isNewCreate: true
                },
                microArticleContentRules: [             // 微文内容的校验
                    v => !!v || '',
                    v => (v && v.length <= 1000) || this.$t('microArticles.contentLimit')
                ],
                voteForm: {                             // 投票微文的对象
                    microArticleId: null,
                    userId: null,
                    status: null
                },
                publishBtnLoading: false,               // 发布微文按钮的加载中
                availableContentLength: 1000,           // 微文内容默认字数
                contentPercentage: 0,                   // 已经输入字数的百分比
                newListPageNo: 0,                       // 按时间排序集合的页码
                hotListPageNo: 0,                       // 按热度排序集合的页码
                searchPageNo: 0,                        // 按文本排序集合的页码
                searchText: '',                         // 搜索的文本
                isLoadingNewList: false,                // 是否正在加载按时间排序的集合
                isLoadingHotList: false,                // 是否正在加载按热度排序的集合
                isLoadingSearchList: false,             // 是否正在加载按文本排序的集合
                isShowSearchField: false,               // 是否显示搜索字段
                microArticleIds: [],                    // 微文主键集合
            }
        },
        created(){

        },
        mounted(){

        },
        watch:{

        },
        components: {
            InfiniteLoading,
        },
        methods: {
            // 根据时间查询微文集合
            getMicroArticleNewList($state){
                if (this.isLoadingNewList) {
                    return;
                }
                this.isLoadingNewList = true;
                let url = config.baseUrl + "microArticle/open/getMicroArticle/"+this.newListPageNo+"/5/new";
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.newListPageNo += 1;
                        this.microArticleNewList = [...this.microArticleNewList, ...data.result];
                        $state.loaded();
                        this.isLoadingNewList = false;
                        if (localStorage.getItem('token')) {
                            this.getVoteList(data.result);
                        }
                    } else {
                        $state.complete();
                    }
                });
            },
            // 根据热度查询微文集合
            getMicroArticleHotList($state){
                if (this.isLoadingHotList) {
                    return;
                }
                this.isLoadingHotList = true;
                let url = config.baseUrl + "microArticle/open/getMicroArticle/"+this.hotListPageNo+"/5/hot";
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.hotListPageNo += 1;
                        this.microArticleHotList = [...this.microArticleHotList, ...data.result];
                        $state.loaded();
                        this.isLoadingHotList = false;
                        if (localStorage.getItem('token')) {
                            this.getVoteList(data.result);
                        }
                    } else {
                        $state.complete();
                    }
                });
            },
            // 根据文本模糊查询微文集合
            getMicroArticleSearchList($state){
                if (this.searchText == null || this.searchText.trim() == 0) {
                    return;
                }
                this.isLoadingsearchList = true;
                let url = config.baseUrl + "microArticle/open/searchMicroArticle/" + this.searchPageNo + "/5/" + this.searchText;
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.searchPageNo += 1;
                        this.microArticleSearchList = [...this.microArticleSearchList, ...data.result];
                        $state.loaded();
                        this.isLoadingsearchList = false;
                    } else {
                        $state.complete();
                    }
                    
                }, error => {

                });
            },
            // 创建微文
            createMicroArticle(){
                if (!localStorage.getItem('token')) {
                    this.$store.state.loginModal = true;
                    return;
                }
                if(this.$refs.microArticleForm.validate()){
                    let url = config.baseUrl + "microArticle/saveMicroArticle";
                    this.publishBtnLoading = true;
                    this.microArticleForm.userId = this.$store.state.user.id;
                    this.microArticleForm.isNewCreate = true;
                    this.$http.post(url, this.microArticleForm).then(response => {
                        let data = response.data;
                        this.publishBtnLoading = false;
                        if (data.resCode == 0) {
                            this.microArticleForm.content = '';
                            this.availableContentLength = 1000;
                            this.contentPercentage = 0;
                            this.gotoMicroArticle(data.result);
                        }
                        
                    }, error => {
                        this.publishBtnLoading = false;
                        this.$Message.error(this.$t('common.fail'));
                    });
                }
            },
            //查看用户详情页面
            goUserData (username) {
                this.$router.push({
                    name: 'userData',
                    params: {
                        username: '@' + username
                    }
                });
            },
            // 跳转微文详情页
            gotoMicroArticle(microArticle){
                this.$router.push({
                    name: 'microArticle',
                    params: {
                        userName: '@' + microArticle.userName,
                        microArticleId: microArticle.microArticleId
                    }
                });
            },
            // 内容改变时触发事件
            changeContent(){
                let contectLength = this.microArticleForm.content.length;
                this.availableContentLength = 1000 - contectLength;
                this.contentPercentage = contectLength / 10;
            },
            // 给微文投票
            voteMicroArticle(microArticle, status){
                if (!localStorage.getItem('token')) {
                    this.$store.state.loginModal = true;
                    return;
                }
                this.voteForm.microArticleId = microArticle.microArticleId;
                this.voteForm.userId = this.$store.state.user.id;
                this.voteForm.status = status;
                let url = config.baseUrl + "microArticle/voteMicroArticle";
                this.$http.post(url, this.voteForm).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        microArticle.isUpvote = true;
                        microArticle.upvoteCount += 1;
                    } else {
                        this.$Message.warning(this.$t('posting.evaluation'));
                    }
                },error => {
                    this.$Message.warning(this.$t('common.fail'));
                });
            },
            // 根据用户主键和微文主键集合查询投票集合
            getVoteList(microArticleList){
                for(let i = 0; i < microArticleList.length; i++){
                    this.microArticleIds[i] = microArticleList[i].microArticleId;
                }
                let url = config.baseUrl + "microArticle/getVoteList/" + this.$store.state.user.id;
                this.$http.post(url, this.microArticleIds).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        // 有投票对象
                        let voteList = data.result;
                        for(let i = 0; i < voteList.length; i++){
                            for(let j = 0; j < microArticleList.length; j++){
                                if (voteList[i].microArticleId == microArticleList[j].microArticleId) {
                                    if ('0' == voteList[i].status) {
                                        microArticleList[j].isUpvote = true;
                                    }
                                }
                            }
                        }
                    }
                    // 完成后强制渲染页面
                    this.$forceUpdate();
                });
            },
            // 格式化时间
            dateFormat(time){
                return formatDate(time, this.$i18n.locale);
            },
        },
    }
</script>


// WEBPACK FOOTER //
// MicroArticles.vue?1969b9e4